import { RecentActivityMemberSummaryDto } from '@core/services/dto/recent-activity-member-summary.dto';

export class RecentActivityMemberSummaryModel {
  memberProfileViewsCount: number;

  constructor(dto: RecentActivityMemberSummaryDto) {
    this.memberProfileViewsCount = dto.memberProfileViewsCount;
  }
}
